import { DialogService, GridAction } from '@eforall/dashboard';
import { Event, EventTypeId } from '@interfaces';
import { EventDialog } from '../../../../../../../ui/widget';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { EventSetKeynoteSpeakerDialog } from '../set-keynote-speaker-dialog/set-keynote-speaker.dialog';

export function getActions(dialogService: DialogService, accAreaService: AcceleratorAreaService) {

	const actions: GridAction<Event>[] = [{
		iconClass: 'fa-regular fa-calendar-lines',
		label: 'Open Event',
		isEnabled: rows => !!rows.length,
		execute: async rows => {
			const eventId = rows[0]?.eventId;
			if (eventId) {
				await dialogService.showCustom(EventDialog, { data: { eventId } }, 900, 700);
				await accAreaService.reloadData();
			}
		}
	},
	{
		iconClass: 'fa-regular fa-calendar-lines',
		label: 'Set Keynote Speaker',
		isEnabled: rows => !!rows.length && rows[0]?.eventTypeId == EventTypeId.AccShowcase,
		execute: async rows => {
			const eventId = rows[0]?.eventId;
			if (eventId) {
				await dialogService.showCustom(EventSetKeynoteSpeakerDialog, { data: {} }, 450, 350);
				await accAreaService.reloadData();
			}
		}
	},
	];

	return actions;
}